import styles from "./AddUserForm.module.scss";
import { useState } from "react";
import { CommonError, User, UserRole } from "../../../interfaces/interfaces";
import { AiOutlineMail } from "react-icons/ai";
import { BsPerson } from "react-icons/bs";
import { FiPhone } from "react-icons/fi";
import { HiOutlineKey } from "react-icons/hi";
import { UsersRestS } from "../../../rest/users-rest-service";
import { Field, Form } from "react-final-form";
import {
  cutomEmailValidation,
  mobileNumberValidation,
  reqiredValidation,
} from "../../../components/functions/formValidation";
import { FORM_ERROR } from "final-form";
// import useAnalyticsEventTracker from "../../../components/Hooks/useAnalyticsEventTracker";
import { AnalyticsEvents } from "../../../components/functions/analyticsEvents";
import { OnChange } from "react-final-form-listeners";
import { RestS } from "../../../rest/rest-service";
import { getLocalUser } from "../../../components/functions/utilities";

type props = {
  user?: User;
  onClose: Function;
  isEdit?: boolean;
};

export default function AddUserForm({ user, onClose, isEdit = false }: props) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const userTypes = UserRole;
  const [loading, setLoading] = useState(false);
  const [showExtraField, setShowExtraField] = useState(false);
  const [currUser, setCurrUser] = useState(user);
  const currentUser = getLocalUser();

  // const gaEventTrackerCF = useAnalyticsEventTracker("Collaboration features");

  const onChangeText = (e) => {
    setCurrUser({ ...currUser, [e.target.name]: e.target.value });
  };
  const renderName = (name) => {
    let userNameSplit = name.split(" ");
    return `${userNameSplit[0].charAt(0)}`.toUpperCase();
  };

  const onSubmit = async (values) => {
    let errors = {
      value: false,
      message: {},
    };
    setLoading(true);

    try {
      if (isEdit) {
        const data = await UsersRestS.updateUser(values);
        onClose();
        setLoading(false);
      } else {
        if (values.role == "Agency" && currentUser?.role !== "Agency") {
          console.log("values", values);
          // return;
          // const data = await RestS.clientInvitingAgency(values);
          // console.log("data received", data);
        } else {
          const data = await UsersRestS.newUser(values);
        }
        // gaEventTrackerCF(AnalyticsEvents.ADD_NEW_USER, "Admin functions");
        onClose();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      const errorData = error.response?.data?.errors as CommonError[];
      if (errorData && errorData.length > 0) {
        const parseError = errorData.reduce((prev, currVal) => {
          prev[currVal.field ? currVal.field : FORM_ERROR] = currVal.message;
          return prev;
        }, {});
        errors = {
          value: true,
          message: parseError,
        };
      } else {
        errors = {
          value: true,
          message: {
            [FORM_ERROR]: "Something went wrong",
          },
        };
      }
    }
    console.log(errors)
    if (errors.value == true) {
      //
      return errors.message;
    }
  };

  const allowOnlyNumber = (value) => {
    //
    const re = /^[0-9\b]+$/;

    // if value is not blank, then test the regex

    if (value === "" || re.test(value)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className={styles.addUserForm}>
      <Form
        // debug={(state, fieldState) => {
        //   console.log("state", state);
        // }}
        onSubmit={(values) => onSubmit(values)}
        validateOnBlur={true}
        initialValues={
          isEdit
            ? { ...user }
            : currentUser?.role == "Agency"
              ? { role: "Agency" }
              : {}
        }
        render={({
          handleSubmit,
          pristine,
          hasValidationErrors,
          submitError,
        }) => (
          <form onSubmit={handleSubmit}>
            <div>
              <div className={styles.profilePicBlock}>
                <div className={styles.imgdiv}>
                  {Boolean(user) ? (
                    <div
                      className={`${styles.profileIcon} rounded-circle`}
                      style={{ cursor: "pointer" }}
                    >
                      {renderName(user.name)}
                    </div>
                  ) : (
                    <div className={`${styles.profileIcon} rounded-circle`}>
                      <BsPerson size={"4rem"} />
                    </div>
                  )}
                </div>
                <Field
                  name="name"
                  validate={(values) => reqiredValidation(values, "Name")}
                >
                  {(props) => {
                    return (
                      <>
                        <input
                          {...props.input}
                          className={`${styles.fullName} ${props.meta.error && props.meta.touched
                            ? styles.invalid
                            : props.meta.submitError
                              ? styles.invalid
                              : ""
                            }`}
                          value={props.input.value}
                          name="name"
                          placeholder="Full Name *"
                          onChange={props.input.onChange}
                          maxLength={25}
                        />

                        {props.meta.error && props.meta.touched ? (
                          <div className={styles.formError}>
                            {props.meta.error}
                          </div>
                        ) : props.meta.submitError ? (
                          <div className={styles.formError}>
                            {props.meta.submitError}
                          </div>
                        ) : null}
                      </>

                      // <CustomInput maxLength={30} {...props.input} value={props.input.value} name="fullName" onChange={props.input.onChange} error={props.meta.error} touched={props.meta.touched} isTextArea={false} />
                    );
                  }}
                </Field>
              </div>
              <hr />

              <div className={styles.infoBlock}>
                <div className={styles.userInfo}>
                  <div className={styles.icon}>
                    {" "}
                    <BsPerson size={"1.3rem"} />
                  </div>
                  <Field name="designation">
                    {(props) => {
                      return (
                        <div className={styles.inputDiv}>
                          <input
                            {...props.input}
                            className={styles.designation}
                            value={props.input.value}
                            onChange={props.input.onChange}
                            name="designation"
                            placeholder="Enter Designation"
                            maxLength={15}
                          />
                        </div>
                      );
                    }}
                  </Field>
                </div>
                <Field
                  name="phoneNumber"
                  validate={(values) => {
                    if (values) {
                      return mobileNumberValidation(values);
                    } else return "";
                  }}
                >
                  {(props) => {
                    return (
                      <>
                        <div className={styles.userInfo}>
                          <div className={styles.icon}>
                            {" "}
                            <FiPhone size={"1.3rem"} />
                          </div>
                          <div className={styles.inputDiv}>
                            <input
                              {...props.input}
                              className={`${styles.mobileNumber} ${props.meta.error && props.meta.touched
                                ? styles.invalid
                                : props.meta.submitError
                                  ? styles.invalid
                                  : ""
                                }`}
                              value={props.input.value}
                              onChange={(e) =>
                                allowOnlyNumber(e.target.value)
                                  ? props.input.onChange(e.target.value)
                                  : {}
                              }
                              name="phoneNumber"
                              placeholder="Enter Phone Number"
                              maxLength={10}
                            />
                          </div>
                        </div>
                        {props.meta.error && props.meta.touched ? (
                          <div
                            className={`${styles.formError} ${styles.addMargin}`}
                          >
                            {props.meta.error}
                          </div>
                        ) : props.meta.submitError ? (
                          <div
                            className={`${styles.formError} ${styles.addMargin}`}
                          >
                            {props.meta.submitError}
                          </div>
                        ) : null}
                      </>
                    );
                  }}
                </Field>

                <Field name="email" validate={cutomEmailValidation}>
                  {(props) => (
                    <>
                      <div className={styles.userInfo}>
                        <div className={styles.icon}>
                          <AiOutlineMail size={"1.3rem"} />
                        </div>
                        <div className={styles.inputDiv}>
                          <input
                            {...props.input}
                            className={`${styles.email}  ${props.meta.error && props.meta.touched
                              ? styles.invalid
                              : props.meta.submitError
                                ? styles.invalid
                                : ""
                              }`}
                            value={props.input.value}
                            onChange={props.input.onChange}
                            name="email"
                            placeholder="Enter Email Address *"
                            disabled={isEdit}
                          />
                        </div>
                      </div>
                      {props.meta.error && props.meta.touched ? (
                        <div
                          className={`${styles.formError} ${styles.addMargin}`}
                        >
                          {props.meta.error}
                        </div>
                      ) : props.meta.submitError ? (
                        <div
                          className={`${styles.formError} ${styles.addMargin}`}
                        >
                          {props.meta.submitError}
                        </div>
                      ) : null}
                    </>
                  )}
                </Field>

                <Field
                  name="role"
                  validate={(values) => reqiredValidation(values, "role")}
                >
                  {(props) => (
                    <>
                      <div className={styles.userInfo}>
                        <div className={styles.icon}>
                          {" "}
                          <HiOutlineKey size={"1.3rem"} />
                        </div>
                        <div className={styles.inputDiv}>
                          <select
                            {...props.input}
                            name="role"
                            className={`form-select p-1 ${styles.selectBox}  ${props.meta.error && props.meta.touched
                              ? styles.invalid
                              : props.meta.submitError
                                ? styles.invalid
                                : ""
                              }`}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            onChange={(e) => {
                              // changeUserRole(e.target.value, user.id)
                              props.input.onChange(UserRole[e.target.value]);
                              // setCurrUser({ ...currUser, role: UserRole[e.target.value] })
                            }}
                          >
                            {currentUser?.role !== "Agency" ? (
                              <>
                                <option value="" disabled selected>
                                  Select
                                </option>
                                <option
                                  value="Admin"
                                  selected={props.input.value == "Admin"}
                                >
                                  Admin
                                </option>
                                <option
                                  value="User"
                                  selected={props.input.value == "User"}
                                >
                                  User
                                </option>
                              </>
                            ) : null}
                            <option
                              value="Agency"
                              selected={props.input.value == "Agency"}
                            >
                              Agency
                            </option>
                          </select>
                        </div>
                      </div>

                      {props.meta.error && props.meta.touched ? (
                        <div
                          className={`${styles.formError} ${styles.addMargin}`}
                        >
                          {props.meta.error}
                        </div>
                      ) : props.meta.submitError ? (
                        <div
                          className={`${styles.formError} ${styles.addMargin}`}
                        >
                          {props.meta.submitError}
                        </div>
                      ) : null}
                    </>
                  )}
                </Field>
                <OnChange name="role">
                  {(value, previous) => {
                    // console.log(currentUser?.role);
                    if (value == "Agency" && currentUser?.role !== "Agency") {
                      setShowExtraField(true);
                    } else {
                      if (showExtraField) {
                        setShowExtraField(false);
                      }
                    }
                  }}
                </OnChange>

                {showExtraField ? (
                  <Field name="companyName" validate={reqiredValidation}>
                    {(props) => (
                      <>
                        <div className={styles.userInfo}>
                          <div className={styles.icon}>
                            <AiOutlineMail size={"1.3rem"} />
                          </div>
                          <div className={styles.inputDiv}>
                            <input
                              {...props.input}
                              className={`${styles.email}  ${props.meta.error && props.meta.touched
                                ? styles.invalid
                                : props.meta.submitError
                                  ? styles.invalid
                                  : ""
                                }`}
                              value={props.input.value}
                              onChange={props.input.onChange}
                              name="companyName"
                              placeholder="Enter Company name *"
                              disabled={isEdit}
                            />
                          </div>
                        </div>
                        {props.meta.error && props.meta.touched ? (
                          <div
                            className={`${styles.formError} ${styles.addMargin}`}
                          >
                            {props.meta.error}
                          </div>
                        ) : props.meta.submitError ? (
                          <div
                            className={`${styles.formError} ${styles.addMargin}`}
                          >
                            {props.meta.submitError}
                          </div>
                        ) : null}
                      </>
                    )}
                  </Field>
                ) : null}


              </div>

            </div>

            <div className={styles.btns}>
              <button
                type="submit"
                disabled={pristine || hasValidationErrors}
                className={`${styles.proceedBtn} ${loading ? styles.loading : ""
                  } demo_invite_user`}
                onClick={() => {
                  handleSubmit();
                }}
              >
                <div className={styles.buttonText}>
                  {isEdit ? "Update" : "Send Invitation"}
                </div>
              </button>

            </div>
            {submitError && (
              <div style={{ textAlign: "center" }} className={styles.formError}>{submitError}</div>
            )}
          </form>

        )}
      />
    </div>
  );
}
